import { useEffect, useRef, useState } from 'react';
import { Badge, Col, Popover, PopoverBody, PopoverHeader } from 'reactstrap';
import api from 'services/api';

interface IEntradaCabecalho {
  setorAtividade?: string[];
  propostaId: number;
}
interface IDadosSetor {
  setor: string;
  descricao?: string | null;
  razaoIndicador?: string;
  funcaoIndicador?: string;
  razaoSuperior?: string;
  funcaoSuperior?: string;
  codigoSuperior?: string;
}

export default function CabecalhoPropostaBadge({
  setorAtividade: setorAtividadeProp,
  propostaId,
}: IEntradaCabecalho): JSX.Element {
  const [setorSelecionado, setSetorSelecionado] = useState<string | null>(null);
  const [dadosSetor, setDadosSetor] = useState<IDadosSetor | null>(null);
  const [carregando, setCarregando] = useState(false);
  const [setorAtividade, setSetorAtividade] = useState<string[]>([]);
  const popoverRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;

      const clicouNaBadge = popoverRef.current?.contains(target);

      const clicouNoPopover = (target as HTMLElement)?.closest('.popover');

      if (!clicouNaBadge && !clicouNoPopover) {
        setSetorSelecionado(null);
        setDadosSetor(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  async function buscarSetores() {
    const response = await api.get(`/proposta/setores/${propostaId}`);

    setSetorAtividade(response.data);
  }

  useEffect(() => {
    if (setorAtividadeProp?.length) {
      // Recebeu pelo componente pai
      setSetorAtividade(setorAtividadeProp);
    } else {
      // Não recebeu, busca no backend
      buscarSetores();
    }
  }, [propostaId, setorAtividadeProp]);

  const buscarDadosSetor = async (setor: string) => {
    try {
      setCarregando(true);

      const response = await api.get(
        `/proposta/versao/cabecalho/${propostaId}/${encodeURIComponent(setor)}`,
      );

      setDadosSetor(response.data[0]);
      setSetorSelecionado(setor);
    } catch (error) {
      console.error('Erro ao buscar dados do setor:', error);
    } finally {
      setCarregando(false);
    }
  };

  const handleBadgeClick = (setor: string) => {
    if (setorSelecionado === setor) {
      setSetorSelecionado(null);
      setDadosSetor(null);
      return;
    }

    buscarDadosSetor(setor);
  };

  return (
    <Col className="d-flex flex-wrap align-items-center gap-1">
      {setorAtividade?.map(setor => {
        const idBadge = `badge-setor-${propostaId}-${setor}`;

        return (
          <div ref={popoverRef} key={setor}>
            <Badge
              id={idBadge}
              color="info"
              role="button"
              onClick={() => handleBadgeClick(setor)}
              style={{ cursor: 'pointer' }}
              className="mr-2"
            >
              {setor}
            </Badge>

            {setorSelecionado === setor && (
              <Popover placement="top" target={idBadge} isOpen>
                <PopoverHeader>
                  {`Setor de Atividade ${setor} - ${dadosSetor?.descricao}:`}
                </PopoverHeader>

                <PopoverBody style={{ fontSize: '1rem' }}>
                  {carregando && <div>Carregando...</div>}

                  {!carregando && dadosSetor && (
                    <div>
                      {dadosSetor.funcaoIndicador && (
                        <div>
                          <strong>Função:</strong> {dadosSetor.funcaoIndicador}
                        </div>
                      )}

                      {dadosSetor.razaoSuperior ? (
                        <>
                          <div>
                            <strong>Superior:</strong>{' '}
                            {dadosSetor.razaoSuperior}
                          </div>

                          {dadosSetor.funcaoSuperior && (
                            <div>
                              <strong>Superior cargo:</strong>{' '}
                              {dadosSetor.funcaoSuperior}
                            </div>
                          )}
                        </>
                      ) : (
                        <div>
                          <strong>Nenhum superior encontrado</strong>
                        </div>
                      )}

                      {dadosSetor.razaoIndicador && (
                        <div>
                          <strong>Empresa:</strong> {dadosSetor.razaoIndicador}
                        </div>
                      )}
                    </div>
                  )}

                  {!carregando && !dadosSetor && (
                    <div>
                      <strong>Nenhum superior encontrado</strong>
                    </div>
                  )}
                </PopoverBody>
              </Popover>
            )}
          </div>
        );
      })}
    </Col>
  );
}
